import {
    IButton,
    IChargeTier,
    IOffers,
    PRICE_VARIABLE
} from '@dazn/lp-web/src/types';
import {getCurrency} from '@dazn/lp-web/src/utils/dazn/Region';
import {getChargeTier, getOfferPrice} from '@dazn/lp-web/src/utils/offer';
import {ringPassDiscountEnabled} from '@dazn/lp-web/src/features/getRingPassDiscount';
import {getPpvDiscountPrice} from '@dazn/lp-web/src/components/BannerSlider/banner-slider.utils';
import {ComponentTypes} from '@dazn/lp-web/src/constants/componentTypes.constants';
import {getFinalPrice} from '@dazn/lp-web/src/components/Countdown/countdown.utils';

export const getButtonLabel = (
    button: IButton,
    offers: IOffers | null,
    from?: string
) => {
    const {label, entitlementSetId, billingPeriod, discountLabel} =
        button ?? {};
    let buttonLabel: any = label;

    const offerDetail =
        offers?.Offers?.find((offer: any) => {
            return (
                offer.EntitlementSetId === entitlementSetId &&
                offer.BillingPeriod === billingPeriod
            );
        }) ?? null;

    const addonDetail =
        offers?.Addons?.find((offer: any) => {
            return offer?.EntitlementSetId === entitlementSetId;
        }) ?? null;

    if (discountLabel) {
        const ppvDiscount = getPpvDiscountPrice(addonDetail);
        if ((ringPassDiscountEnabled() && addonDetail, ppvDiscount)) {
            buttonLabel = discountLabel.replace(PRICE_VARIABLE, ppvDiscount);
            return buttonLabel;
        }
    }

    if (buttonLabel?.includes(PRICE_VARIABLE) && entitlementSetId) {
        let chargeTier: IChargeTier | null = null;

        if (billingPeriod) {
            if (
                offerDetail &&
                offerDetail?.ChargeTiers?.length > 0 &&
                getChargeTier(offerDetail?.ChargeTiers, getCurrency())
            ) {
                chargeTier = getChargeTier(
                    offerDetail.ChargeTiers,
                    getCurrency()
                );
            }
        } else {
            if (
                addonDetail &&
                addonDetail?.ChargeTiers?.length > 0 &&
                getChargeTier(addonDetail?.ChargeTiers, getCurrency())
            ) {
                chargeTier = getChargeTier(
                    addonDetail.ChargeTiers,
                    getCurrency()
                );
            }
        }

        if (chargeTier?.Price && chargeTier?.Currency) {
            const offerPrice = getOfferPrice(
                chargeTier.Price,
                chargeTier.Currency,
                label
            );

            if (offerPrice?.price) {
                buttonLabel = offerPrice?.price;
            }

            if (
                offerPrice?.price &&
                from &&
                from === ComponentTypes.VIDEO_PLAYER
            ) {
                buttonLabel = getFinalPrice(label, offerPrice?.price);
            }
        }
    }

    return buttonLabel;
};
